import {Project} from "../../../core/Utils";

const FORM_BROAD_NARROW = 'broad-narrow'
const FORM_BROAD_NARROW_GUIDE = 'broad-narrow-guide'
const FORM_DEEP_CUSTOMER_EMPATHY = 'deep-customer-empathy'
const FORM_INTERVIEW_GUIDE = 'interview-guide'
const FORM_EMPATHY_MAP = 'empathy-map'
const FORM_CUSTOMER_PROBLEM = 'customer-problem'
const FORM_IDEAL_STATE = 'ideal-state'
const FORM_BRAINSTORMING = 'brainstorming'
const FORM_TOP_IDEAS = 'top-ideas'
const FORM_SKETCH = 'sketch'
const FORM_LOF_ASSUMPTIONS = 'lof-assumptions'
const FORM_HYPOTHESIS = 'hypothesis'
const FORM_DEBRIEF_EXPERIMENT = 'debrief-experiment'
const FORM_NEXT = 'next'
const FORM_GO_NARROW_TECHNIQUES = 'go-narrow-techniques'
const FORM_EXPERIMENT_INSTRUCTIONS = 'experiment-instructions'
const FORM_TYPES_OF_EXPERIMENTS = 'types-of-experiments'
const FORM_RAPID_EXPERIMENTS_CUSTOMERS = 'rapid-experiments-with-customers'

function getStepFromForm(formName) {
    switch (formName) {
        case FORM_DEEP_CUSTOMER_EMPATHY:
            return 2
        case FORM_INTERVIEW_GUIDE:
            return 3
        case FORM_EMPATHY_MAP:
            return 4
        case FORM_CUSTOMER_PROBLEM:
            return 5
        case FORM_IDEAL_STATE:
            return 6
        case FORM_BROAD_NARROW:
            return 7
        case FORM_BROAD_NARROW_GUIDE:
            return 8
        case FORM_BRAINSTORMING:
            return 9
        case FORM_GO_NARROW_TECHNIQUES:
            return 10
        case FORM_TOP_IDEAS:
            return 11
        case FORM_SKETCH:
            return 12
        case FORM_RAPID_EXPERIMENTS_CUSTOMERS:
            return 13
        case FORM_LOF_ASSUMPTIONS:
            return 14
        case FORM_TYPES_OF_EXPERIMENTS:
            return 15
        case FORM_HYPOTHESIS:
            return 16
        case FORM_EXPERIMENT_INSTRUCTIONS:
            return 17
        case FORM_DEBRIEF_EXPERIMENT:
            return 18
        case FORM_NEXT:
            return 19
    }
    return 0
}

function getStepForDisplay(step) {
    return (step === Project.PROJECT_TOTAL_PAGE[Project.PROJECT_D4D] - 1 ||
        step === Project.PROJECT_TOTAL_PAGE[Project.PROJECT_JOB_SHADOW] - 1 ||
        step === Project.PROJECT_TOTAL_PAGE[Project.PROJECT_BE_ENTREPRENEURIAL] - 1 ||
        step === 0) ? step + 1 : step
}

export default {
    FORM_BROAD_NARROW_GUIDE,
    FORM_BROAD_NARROW,
    FORM_DEEP_CUSTOMER_EMPATHY,
    FORM_INTERVIEW_GUIDE,
    FORM_EMPATHY_MAP,
    FORM_CUSTOMER_PROBLEM,
    FORM_IDEAL_STATE,
    FORM_BRAINSTORMING,
    FORM_TOP_IDEAS,
    FORM_SKETCH,
    FORM_LOF_ASSUMPTIONS,
    FORM_HYPOTHESIS,
    FORM_DEBRIEF_EXPERIMENT,
    FORM_NEXT,
    FORM_GO_NARROW_TECHNIQUES,
    FORM_EXPERIMENT_INSTRUCTIONS,
    FORM_TYPES_OF_EXPERIMENTS,
    FORM_RAPID_EXPERIMENTS_CUSTOMERS,
    getStepFromForm,
    getStepForDisplay
}
